
namespace RioERP.Products {
    export class SubjectsColumns {
        static columnsKey = 'Products.Subjects';
    }
}